import styled from 'styled-components';
import { Card } from 'antd';

export const Wrapper = styled(Card)`
  margin-top: 0%!important;;
  margin-right: 8% !important;;
  margin-left: 8% !important;;
  margin-bottom: 10 !important;;
  /* padding: 0; */
  border: 0;
  /* background-color: red; */
  .ant-card-body{

    /* margin: 0px !important; */
    margin-top: 30px;
    margin-bottom: 10px;
    /* padding: 0; */
  }
  .areaButton{
    /* margin-top: 30px; */
    align-items: center;
    justify-content:space-around;
    /* display:inline-flexbox; */
    /* justify-content:space-around; */
    /* display: flex; */
    display: flex;
    flex-direction: row;
    

  }
  .conteudoModal {
    background: red !important;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .areaButton Button{
    border: none;
    width: 40%;
    align-items: center;
    height: 40px;
    margin-top: 10px;
    /* margin:10px; */
    background-color:#778899	;
    /* justify-content: space-between !important; */
    align-items: center;

  }
  .areaButtonSubmit {

    /* background-color: red; */
    margin-top: 50px;
    display: flex;
    justify-content: center;
  }
  .areaButtonSubmit Button{
    border: none;
    width: 250px;
    align-items: center;
    height: 40px;
    margin:10px;
    background-color:#778899	;
    background-color: green;
     /* justify-content: space-between !important; */
    align-items: center; 

  }
  @media (max-width: 1200px) {
     .areaButton{
       /* background-color:red; */
       /* align-items:center;  */
       display: flex;
       flex-direction: column;
     }
     .areaButton Button{
       min-width: 80%;
      /* margin-top: 10px; */
     }
       }
`;


